import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧情", to: "/category/plot" },
  { label: "演员", to: "/category/cast" },
  { label: "剧评", to: "/category/reviews" },
  { label: "动态", to: "/category/news" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const isActive = (to: string) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 border-b border-background-300 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-content items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-base font-bold tracking-wide text-foreground-950">
              我的朋友他的妻子
            </span>
            <span className="font-label text-[11px] text-foreground-500">
              影视专题 · 剧情解读
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-50 font-medium text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/category/news"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3.5 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600 md:flex"
          >
            <i className="ri-flashlight-line"></i>
            追更动态
          </Link>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-2 md:hidden">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center justify-between rounded-md px-3 py-3 text-sm ${
                isActive(item.to)
                  ? "bg-primary-50 font-medium text-primary-700"
                  : "text-foreground-700"
              }`}
            >
              {item.label}
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}